import { ComponentProps } from "@ts/components";
import { useFilterListProps } from "@usereactify/search";
import React from "react";
import { FilterSectionBox } from "./FilterSectionBox";
import { FilterSectionList, FilterSectionListProps } from "./FilterSectionList";
import { FilterSectionSwatch } from "./FilterSectionSwatch";

type FilterSectionListSelectorInputProps = ComponentProps &
  ReturnType<typeof useFilterListProps> &
  FilterSectionListProps;

export const FilterSectionListSelector = (
  props: FilterSectionListSelectorInputProps,
) => {
  return (
    <>
      {props.filter.displayView === `box` ? (
        <FilterSectionBox {...props} />
      ) : props.filter.displayView === `swatch` ? (
        <FilterSectionSwatch
          value={props.value as Record<string, boolean>}
          handleChange={props.handleChange}
          options={props.options}
        />
      ) : (
        <FilterSectionList {...props} />
      )}
    </>
  );
};
